
import { Options, Vue } from 'vue-class-component';

import VIcon from '@/components/UI/VIcon.vue';
import ShootingPinTableLine from '@/components/Shootings/ShootingPinTableLine.vue';

import { Point } from '@/classes/Point';
import { Plan } from '@/classes/Plan';

@Options({
  name: 'ShootingPinTable',
  components: {
    VIcon,
    ShootingPinTableLine,
  },

  props: {
    panoramas: Array,
    activePanoramaIndex: Number,
    plans: Array,
    points: Array,
    unpinButtonIsEnabled: Boolean,
  },

  methods: {
    getPlan(panoramaIndex: number) {
      const pointId = this.panoramas[panoramaIndex].pointId;

      if (!pointId) {
        return '-';
      }

      const point = this.points.find((point: Point) => point.id === pointId);
      const planId = point.planId;
      const plan = this.plans.find((plan: Plan) => plan.id === planId);
      return plan.title;
    },
  },
})
export default class ShootingCreatePinTable extends Vue {}
